<template>
  <el-dialog
    :close-on-click-modal="false"
    class="dialog-style-public"
    title="用户反馈"
    :visible="visible"
    width="480px"
    top="5vh"
    :append-to-body="true"
    :before-close="onClose"
  >
    <div class="ai-feedback-modal">
      <div class="ai-feedback-body">
        <div class="ai-feedback-label required" style="margin-top: 0">
          <span class="tiptext">反馈内容问题</span><span>（可多选）</span>
        </div>
        <div class="ai-feedback-reasons">
          <button
            v-for="reason in feedbackReasons"
            :key="reason.code || reason.label"
            type="button"
            class="ai-feedback-tag"
            :class="{
              active: feedbackForm.reasons.includes(reason.code || reason),
            }"
            @click="onToggleReason && onToggleReason(reason)"
          >
            {{ reason.label || reason }}
          </button>
        </div>
        <div class="ai-feedback-label">其他<span> (选填)</span></div>
        <textarea
          class="ai-feedback-textarea"
          placeholder="请输入您的建议或其他问题"
          v-model="feedbackForm.otherText"
        ></textarea>
        <div class="ai-feedback-label">截图<span> (选填)</span></div>
        <el-upload
          class="ai-feedback-upload-card"
          :class="{ 'ai-feedback-uploading': feedbackUploading }"
          action
          list-type="picture-card"
          :http-request="ossUploadRequest"
          :file-list="feedbackFileList"
          :on-preview="onPreview"
          :on-remove="onRemove"
          :on-change="onUploadChange"
        >
          <i class="el-icon-plus"></i>
        </el-upload>
        <el-dialog
          :visible="previewVisible"
          width="60%"
          title="图片详情"
          append-to-body
          class="dialog-style-public no-header-dialog"
          @close="$emit('update:previewVisible', false)"
        >
          <img width="100%" :src="feedbackPreviewImage" alt="" />
        </el-dialog>
      </div>
      <div class="dialog-btn dialogMargin">
        <el-button
          type="primary"
          class="ai-feedback-cancel"
          @click="onClose && onClose()"
          >返回</el-button
        >
        <el-button
          type="success"
          class="ai-feedback-confirm"
          :loading="feedbackUploading"
          :disabled="feedbackUploading"
          @click="onConfirm && onConfirm()"
          >确认</el-button
        >
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "FeedbackDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    feedbackReasons: {
      type: Array,
      default: () => [],
    },
    feedbackForm: {
      type: Object,
      required: true,
    },
    feedbackFileList: {
      type: Array,
      default: () => [],
    },
    feedbackUploading: {
      type: Boolean,
      default: false,
    },
    feedbackPreviewImage: {
      type: String,
      default: "",
    },
    previewVisible: {
      type: Boolean,
      default: false,
    },
    ossUploadRequest: {
      type: Function,
      required: true,
    },
    onToggleReason: {
      type: Function,
      required: true,
    },
    onClose: {
      type: Function,
      required: true,
    },
    onConfirm: {
      type: Function,
      required: true,
    },
    onUploadChange: {
      type: Function,
      required: true,
    },
    onRemove: {
      type: Function,
      required: true,
    },
    onPreview: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {};
  },
};
</script>
